import ResearchImg from "../../Images/research.png";
export function RandD() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title"> Research And Development </h2>
              <p>
                Krufren's dedicated Research and Development department is
                composed of approximately 10+ scientists. We take pride in
                having highly qualified professionals with deep scientific
                knowledge who are actively engaged in developing challenging
                molecules, niche molecules, complex iron molecules, peptide
                molecules, complex polymer molecules, chiral molecules,
                polymorphism, and novel intermediate compounds. The core focus
                of our R&D work primarily centers on the development of generic
                molecules through non-infringing synthesis routes, as well as
                innovative processes.{" "}
              </p>

              <p>
                We have an excellent analytical team that is actively developing
                new analytical methods for both drug substances and drug
                products. This analytical team possesses a high level of
                expertise in developing critical methods for complex iron
                molecules, peptide molecules, complex polymer molecules, and
                conducting sameness studies with the Reference Listed Drug
                (RLD). Additionally, we have a dedicated analytical team
                specifically focused on in vitro studies.
              </p>
              <p>
                We have a strong intellectual property rights team that focuses
                on non-infringing routes of molecules, responding to customer
                queries, preparing patents landscaping, and freedom to operate
                opinions for drug substances and drug products.
              </p>
            </div>
          </div>

          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={ResearchImg} alt="about" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
